module.exports = __webpack_public_path__ + "static/media/masterCard.ff9ab0d0.png";